import { Component, OnInit } from '@angular/core';
export class HeaderComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-header',
  template: `
    <h1>
      <ng-content></ng-content>
    </h1>
  `,
  styles: [`
    h1 {
      color: blueviolet;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function HeaderComponent_tsickle_Closure_declarations() {
/** @type {?} */
HeaderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
HeaderComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
